import { useEffect, useState } from 'react';
import HttpClient from '../helpers/HttpClient';
import { Container, Group, Loader, Table, ActionIcon } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { Contract } from '../types/contract.type';
import { IconPlus } from '@tabler/icons-react';

export const ContractListForPerson = ({ personId }: { personId: number }) => {
  const [loading, setLoading] = useState<boolean>();
  const [gridData, setGridData] = useState<Contract[]>([]);
  const httpClient = new HttpClient<Contract>('/contract');
  const navigate = useNavigate();

  const fetchData = async () => {
      setLoading(true);
      try {
        if (personId) {
          const response = await httpClient.getAllPaged({ personId: personId.toString() });
          setGridData(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch data', error);
      } finally {
        setLoading(false);
      }
    };
  
  useEffect(() => {
    fetchData();
  }, []);

    return (
      <>
      <Container fluid >
          <Group gap={25} visibleFrom="xs">
            <h1>Contracts</h1>
            <ActionIcon variant="filled" size="xl" radius="xl" aria-label="Settings" onClick={() => navigate(`/contract/create?personId=${personId}`)}>
              <IconPlus style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>            
          </Group>
      </Container>
      <Container fluid>
        {loading ? (
          <Loader size="md" />
        ) : (
          <Table striped highlightOnHover withTableBorder withColumnBorders>
            <Table.Tbody>
              {gridData.map((contract) => (
                <Table.Tr key={contract.id} onClick={() => navigate(`/contract/edit/${contract.id}`)} style={{ cursor: 'pointer' }}>
                  <Table.Td>{contract.contractType}</Table.Td>
                  <Table.Td>
                    { contract.validFrom ? dayjs(contract.validFrom).format('DD.MM.YYYY') : '' }                  
                  </Table.Td>
                  <Table.Td>
                    { contract.validTo ? dayjs(contract.validTo).format('DD.MM.YYYY') : '' }
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        )}
      </Container>
    </>
    )
  };